// extracted by mini-css-extract-plugin
module.exports =  {"root":"d6tkDi","disclaimersRoot":"EK3sKW","totalSubLabel":"wFLqv9"};